//import {getAllLanguagesEndPoint} from '../util/apiEndpoints';
import {HttpClient} from "../index";

class LanguageManager {
    /*
        returns an array with objects with all languages.
        [
            {
                "languageId": 1,
                "languageName": "Svenska",
                "languageCode": "sv"
            }
        ]
    */
    // getAll () {
    //     const httpClient = new HttpClient();
    //     return httpClient.get(getAllLanguagesEndPoint());
    // }
}

const languageManager = new LanguageManager();
export default languageManager;


// WEBPACK FOOTER //
// ./retts/Language/LanguageManager.js